@if (isVisible()) {
  <div class="overlay" (click)="onCancel()">
    <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="navigation-confirm-dialog-title" (click)="$event.stopPropagation()">
      <div class="dialog__body">
        <div class="dialog__title-row">
          @switch (iconKind()) {
            @case ('warning') {
            <img
              class="dialog__icon"
              ngSrc="/navigation-confirm-dialog/warning.svg"
              width="28"
              height="28"
              alt=""
              aria-hidden="true"
            />
            }
            @case ('error') {
            <img
              class="dialog__icon"
              ngSrc="/navigation-confirm-dialog/negative.svg"
              width="28"
              height="28"
              alt=""
              aria-hidden="true"
            />
            }
          }
          <p id="navigation-confirm-dialog-title" class="dialog__title">{{ title() }}</p>
        </div>
        <p class="dialog__message">{{ message() }}</p>
      </div>
      <div class="dialog__actions">
        <button class="btn btn--primary" type="button" (click)="onConfirm()">
          {{ okLabel() }}
        </button>
        @if (cancelLabel()) {
          <button class="btn btn--cancel" type="button" (click)="onCancel()">
            {{ cancelLabel() }}
          </button>
        }
      </div>
    </div>
  </div>
}
